module.exports = __webpack_public_path__ + "static/img/honor13.886a1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/honor/honor13.png
// module id = 5dFk
// module chunks = 0